import React from 'react';
import { TypeOfEntityType } from 'models/Task';
import { ValidationErrors } from 'constants/validations';
import { BrandSelect, ClientSelect, CountrySelect, Form, Input, SupplierSelect } from 'components';

export const EntityValue = ({ entity = '' }: { entity: TypeOfEntityType | '' }) => {
  switch (entity) {
    case '':
      return null;
    case 'BRAND':
      return (
        <Form.Item
          name="entityId"
          label="Entity Value*"
          rules={[{ required: true, message: 'Please select entity value' }]}
        >
          <BrandSelect size={'large'} />
        </Form.Item>
      );
    case 'SUPPLIER':
      return (
        <Form.Item
          name="entityId"
          label="Entity Value*"
          rules={[{ required: true, message: 'Please select entity value' }]}
        >
          <SupplierSelect size={'large'} />
        </Form.Item>
      );
    case 'CLIENT':
      return (
        <Form.Item
          name="entityId"
          label="Entity Value*"
          rules={[{ required: true, message: 'Please select entity value' }]}
        >
          <ClientSelect size={'large'} />
        </Form.Item>
      );
    case 'COUNTRY':
      return (
        <Form.Item
          name="entityId"
          label="Entity Value*"
          rules={[{ required: true, message: 'Please select entity value' }]}
        >
          <CountrySelect size={'large'} />
        </Form.Item>
      );
    default:
      return (
        <Form.Item
          label={'Entity Id'}
          name="entityId"
          rules={[{ required: true, message: ValidationErrors.required('Entity Id') }]}
        >
          <Input size={'large'} placeholder={`Enter Entity Id`} />
        </Form.Item>
      );
  }
};
